/**
 * Normalizes a phone number by:
 * - Prepending the default country code if no international prefix is present
 * - Stripping dashes, spaces, parentheses, and dots
 */
export function normalizePhone(phone: string | undefined | null, countryCode: string): string | undefined {
  if (!phone) return phone ?? undefined;
  // Strip formatting characters
  let p = phone.trim().replace(/[\s\-().]/g, '');
  if (!p) return p;
  if (p.startsWith('+')) return p;
  if (p.startsWith('00')) return '+' + p.slice(2);
  if (p.startsWith('0')) return countryCode + p.slice(1);
  return countryCode + p;
}
